export default __webpack_public_path__ + "static/media/c2ebb33f95dcc847fe95d1afc038a68a1581605984276.6bc33cf6.webp";